var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{fading: _vm.fading},attrs:{"id":"scroll-prompt"}},[_c('vue100vh',{staticStyle:{"{height":"'100rvh'}"}},[(_vm.active)?_c('img',{staticClass:"bounce",attrs:{"src":_vm.asset('images/sales/scroll-prompt.svg')}}):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }